// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QoHCv{display:flex;width:100%;margin-bottom:36px;justify-content:space-around}.GmMhA{margin-top:16px;margin-bottom:24px;width:100%}.DZ0DN{text-align:start}.lDokc{display:flex;align-items:flex-start;flex-direction:column}.cD3Uv{display:flex;flex-direction:column;gap:16px}.gwwQX{display:flex;align-items:flex-start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldsContainer": `QoHCv`,
	"inputField": `GmMhA`,
	"infoParagraph": `DZ0DN`,
	"reasonContainer": `lDokc`,
	"fieldsWrapper": `cD3Uv`,
	"checkbox": `gwwQX`
};
export default ___CSS_LOADER_EXPORT___;
